import create from 'zustand';
import type { SurveyQuestion } from '../../../../domain/Surveys/Questions/SurveyQuestion';

export type SelectedQuestion = SurveyQuestion['uuid'] | 'ALL';

export type SelectedQuestions = Partial<
  Record<SiteId, Partial<Record<number, SelectedQuestion | undefined>>>
>;

type SelectedQuestionState = {
  selectedQuestions: SelectedQuestions;
  setSelectedQuestion: (siteId: SiteId, widgetId: number, selection: SelectedQuestion) => void;
};

export const useSelectedQuestionStore = create<SelectedQuestionState>((set) => ({
  selectedQuestions: {},
  setSelectedQuestion: (siteId: SiteId, widgetId: number, selection: string) =>
    set((current) => ({
      selectedQuestions: {
        ...current.selectedQuestions,
        [siteId]: { ...current.selectedQuestions[siteId], [widgetId]: selection },
      },
    })),
}));
